var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.params.clickCallback)?_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),(!_vm.params.clickCallback && _vm.url)?_c('router-link',{attrs:{"tag":"a","to":_vm.url}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }